import { Component, OnInit, HostListener } from '@angular/core';
import { UserService } from '@core/auth/user/user.service';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import {
  ConfirmationModalConfig,
  ConfirmationModalService,
} from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  innerWidth: any = undefined;
  isShow: boolean = true;
  mdlOpen: boolean = false;

  constructor(
    private _ConfirmationModalService: ConfirmationModalService,
    public _UserService: UserService) {

  }

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.innerWidth = event?.target?.innerWidth ?? event;
    if (this.innerWidth < 992) {
      if (this.isShow && !this.mdlOpen) {
        const customConfig: ConfirmationModalConfig = {
          data: {
            icon: 'error',
            msg: 'This Portal only works on Desktop view',
            btnClose: 'Okay',
            allowOutsideClick: false,
            allowEscapeKey: false,
          },
        };
        this._ConfirmationModalService
          .init(ConfirmationComponent, customConfig)
          .subscribe((events: any) => {
            this.mdlOpen = false;
            events.initRef.close();
          });
        this.mdlOpen = true;
      }
      this.isShow = false;
    } else {
      this.isShow = true;
      // this.mdlOpen = false;
    }
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.onResize(this.innerWidth); // Check screen size on initialization
  }
}
